import ConfirmClinicalVerification from '../components/cohorts/ConfirmClinicalVerification.vue';

export const getDemographics = () => ({
  ageRange: [0, 90],
  years: [2018, new Date().getFullYear()],
  genders: [
    'Female', 'Male'
  ],
  insurances: ['Commercial', 'Medicare', 'Medicaid', 'Other'],
  ages: ['0-17', '18-34', '35-44', '45-54', '55-64', '65+'],
  states: [
    { text: "Alabama", value: "AL" },
    { text: "Alaska", value: "AK" },
    { text: "Arizona", value: "AZ" },
    { text: "Arkansas", value: "AR" },
    { text: "California", value: "CA" },
    { text: "Colorado", value: "CO" },
    { text: "Connecticut", value: "CT" },
    { text: "Delaware", value: "DE" },
    { text: "District Of Columbia", value: "DC" },
    { text: "Florida", value: "FL" },
    { text: "Georgia", value: "GA" },
    { text: "Hawaii", value: "HI" },
    { text: "Idaho", value: "ID" },
    { text: "Illinois", value: "IL" },
    { text: "Indiana", value: "IN" },
    { text: "Iowa", value: "IA" },
    { text: "Kansas", value: "KS" },
    { text: "Kentucky", value: "KY" },
    { text: "Louisiana", value: "LA" },
    { text: "Maine", value: "ME" },
    { text: "Maryland", value: "MD" },
    { text: "Massachusetts", value: "MA" },
    { text: "Michigan", value: "MI" },
    { text: "Minnesota", value: "MN" },
    { text: "Mississippi", value: "MS" },
    { text: "Missouri", value: "MO" },
    { text: "Montana", value: "MT" },
    { text: "Nebraska", value: "NE" },
    { text: "Nevada", value: "NV" },
    { text: "New Hampshire", value: "NH" },
    { text: "New Jersey", value: "NJ" },
    { text: "New Mexico", value: "NM" },
    { text: "New York", value: "NY" },
    { text: "North Carolina", value: "NC" },
    { text: "North Dakota", value: "ND" },
    { text: "Ohio", value: "OH" },
    { text: "Oklahoma", value: "OK" },
    { text: "Oregon", value: "OR" },
    { text: "Pennsylvania", value: "PA" },
    { text: "Rhode Island", value: "RI" },
    { text: "South Carolina", value: "SC" },
    { text: "South Dakota", value: "SD" },
    { text: "Tennessee", value: "TN" },
    { text: "Texas", value: "TX" },
    { text: "Utah", value: "UT" },
    { text: "Vermont", value: "VT" },
    { text: "Virginia", value: "VA" },
    { text: "Washington", value: "WA" },
    { text: "West Virginia", value: "WV" },
    { text: "Wisconsin", value: "WI" },
    { text: "Wyoming", value: "WY" }
  ],
  'North East': ["ME", "NH", "VT", "MA", "RI", "CT", "NY", "NJ", "DE", "PA", "MD", "DC"],
  'South East': ["VA", "WV", "KY", "TN", "LA", "AR", "NC", "SC", "GA", "AL", "MS", "FL"],
  'Mid West': ["OH", "KS", "NE", "SD", "ND", "IN", "IL", "MO", "IA", "MN", "WI", "MI"],
  'South West': ["OK", "TX", "NM", "AZ"],
  'West': ["CO", "WY", "MT", "UT", "NV", "CA", "OR", "WA", "ID", "AK", "HI"],
});

export const regionalizeStates = arr => {
  var demographics = getDemographics();
  var selected = arr.reduce((acc, f) => { acc[f] = true; return acc; }, {});
  var regions = [];
  var restOfStates = ['Mid West', 'North East', 'South East', 'South West', 'West']
    .reduce((acc, key) => {
      if (demographics[key].all(f => selected[f])) {
        regions.push({
          label: key,
          states: demographics[key]
        });
        return acc.filter(f => !demographics[key].includes(f));
      }
      return acc;
    }, arr);
  var restOfStatesNames = restOfStates
    .map(f => ({
      label: demographics.states.find(g => g.value === f).text,
      states: [f]
    }));
  return regions.concat(restOfStatesNames);
}

export function confirmClinicalVerification() {
  return this.$confirm('Confirm Clinical Verification Submission', null,
    {
      optionComponent: ConfirmClinicalVerification,
      okText: 'Send for Verification',
      okTitle: 'Submit the cohort now for clinical review. This action is final.',
      cancelText: 'Keep Editing',
      cancelTitle: 'Return to the form to review or update the cohort details.',
      option: {
      },
    });
}
